import script from "./SendGoods.vue?vue&type=script&lang=ts&setup=true"
export * from "./SendGoods.vue?vue&type=script&lang=ts&setup=true"

import "./SendGoods.vue?vue&type=style&index=0&id=76e8b172&lang=scss&scoped=true"
import "./SendGoods.vue?vue&type=style&index=1&id=76e8b172&lang=css"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76e8b172"]])

export default __exports__